/**
 * Created by Zac on 2/03/2016.
 */


$(document).ready(function () {

    $('.sequence-activity .activity-separator').each(function(index){
        var beforeDiv = $(this).closest('.sequence-activity-row, .sequence-activity-wrapper');
        ($(this)).insertAfter(beforeDiv);
    });

});





// WEBPACK FOOTER //
// Glasshouse/Core/js/elementRearrangement.js